import * as requestFromServer from "./superAdminDashboardApis";
import Actions from "../../actions";

// super admin dashboard -> get super admin dashboard index api
export const getSuperAdminDashboardIndexAction = (setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getSuperAdminDashboardIndex();
  if (response) {
    dispatch(Actions.createAction(Actions.GET_SUPER_ADMIN_DASHBOARD_INDEX_LIST, {superAdminDashboardIndex:response}))
    setLoading(false);
    return response;
  }
  else {
    setLoading(false)
    return null
  }
};

// super admin dashboard -> get super admin dashboard order metrics api
export const getSuperAdminDashboardOrderMetricsAction = (setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getSuperAdminDashboardOrderMetrics();
  if (response) {
    dispatch(Actions.createAction(Actions.GET_SUPER_ADMIN_DASHBOARD_ORDER_METRICS_LIST, {superAdminDashboardOrderMetrics:response}))
    setLoading(false);
    return response;
  }
  else {
    setLoading(false)
    return null
  }
};

// super admin dashboard -> get super admin dashboard sales metrics api
export const getSuperAdminDashboardSalesMetricsAction = (setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getSuperAdminDashboardSalesMetrics();
  if (response) {
    dispatch(Actions.createAction(Actions.GET_SUPER_ADMIN_DASHBOARD_SALES_METRICS_LIST, {superAdminDashboardSalesMetrics:response}))
    setLoading(false);
    return response;
  }
  else {
    setLoading(false)
    return null
  }
};